module.exports = __webpack_public_path__ + "img/global-bg.6b5d8e48.png";